import { TextField } from '@mui/material';
import { withStyles } from '@mui/styles';

export const LegacyMuiTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root.Mui-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f !important',
      },
    },
    '& .MuiOutlinedInput-root.MuiInputBase-multiline': {
      padding: 0,
    },
    '& .MuiOutlinedInput-input': {
      padding: '3px 6px',
      borderRadius: '4px',
      fontSize: '14px',
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  },
})(TextField);
